(function () {
  "use strict";

  var ROOT_SELECTOR = "[data-kit-set-precision]";
  var COUNTER_SELECTOR = "[data-precision-counter]";
  var DURATION_MS = 2400;

  function formatValue(n, suffix) {
    return (
      Math.round(n).toLocaleString("en-US", { maximumFractionDigits: 0 }) +
      (suffix || "")
    );
  }

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function applyFinal(el) {
    var target = parseInt(el.getAttribute("data-target"), 10) || 0;
    var suffix = el.getAttribute("data-suffix") || "";
    el.textContent = formatValue(target, suffix);
  }

  function animateCounter(el) {
    var target = parseInt(el.getAttribute("data-target"), 10) || 0;
    var suffix = el.getAttribute("data-suffix") || "";

    if (target <= 0 || prefersReducedMotion()) {
      applyFinal(el);
      return;
    }

    var start = null;

    function tick(ts) {
      if (start == null) start = ts;
      var progress = Math.min((ts - start) / DURATION_MS, 1);
      // ease-out quad
      var eased = 1 - (1 - progress) * (1 - progress);
      el.textContent = formatValue(target * eased, suffix);
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = formatValue(target, suffix);
      }
    }

    el.textContent = formatValue(0, "");
    requestAnimationFrame(tick);
  }

  function initRoot(root) {
    if (root.dataset.precisionInit === "true") return;

    var counters = root.querySelectorAll(COUNTER_SELECTOR);
    if (!counters.length) return;

    if (prefersReducedMotion()) {
      counters.forEach(applyFinal);
      root.dataset.precisionInit = "true";
      return;
    }

    if (typeof IntersectionObserver === "undefined") {
      counters.forEach(animateCounter);
      root.dataset.precisionInit = "true";
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          if (root.dataset.precisionInit === "true") return;
          root.dataset.precisionInit = "true";
          counters.forEach(animateCounter);
          observer.disconnect();
        });
      },
      { root: null, threshold: 0.35 }
    );

    observer.observe(root);
  }

  function init() {
    document.querySelectorAll(ROOT_SELECTOR).forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
